import { addNotification, getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicy } from '../../actions/policy/reducePolicy';
import { selectPolicy } from '../../selectors/policy/selectPolicy';

export function* getOptaEstimatorSaga(action) {
    try {
        yield put(reduceLoading({ code: 'getOptaEstimator', value: true }));
        const session = yield getSessionSaga();
        const policy = yield select(selectPolicy());

        const response = yield call(fetch, '/api/policyTransaction/action/getOptaEstimator', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ policyTransaction: policy }),
        });

        const result = yield call([response, 'json']);

        if (result.operation.status) {
            yield put(reducePolicy(result.policyTransaction));
            window.location.reload();
            return;
        }

        yield put(reduceOperation(result.operation));
        yield put(
            addNotification({
                code: 'getOptaEstimator',
                type: 'error',
                errors: result.operation?.errors,
                message: action?.payload?.errorMessage,
            }),
        );
    } catch (error) {
        // A failed request can respond with a non-JSON body, so parsing throws before any operation exists.
        console.log('Error while calling Get Opta Estimator API - ', error);
        yield put(
            addNotification({
                code: 'getOptaEstimator',
                type: 'error',
                message: action?.payload?.errorMessage,
            }),
        );
    } finally {
        yield put(reduceLoading({ code: 'getOptaEstimator', value: false }));
    }
}
